import { AboutTheAccidentForm } from "./Form";
import useAboutTheAccident from "./hooks/useAboutTheAccident";

export const AboutTheAccident = () => {
  const props = useAboutTheAccident();
  return <AboutTheAccidentForm {...props} />;
};

export default AboutTheAccident;
